import { action } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { DbKey } from '../../../../../adl-gen/common/db';
import { WorkRole } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { WorkRoleListEntry } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { WorkRoleReferenceData } from '../../../../../adl-gen/totalinteraction/futurefit/requests';
import { WorkRoleStore, WorkRoleUpdate } from '../../../../stores';
import { FormMode, toastOptions } from '../../../common/form';
import { WorkRoleEditor } from '../../editors/workrole-editor/workrole-editor';

// tslint:disable-next-line: no-import-side-effect ordered-imports
import '../../../widgets/toast/toastify.css';

// TODO:
// TODO: AppClientId for client admins
// TODO:

interface WorkRoleFormProps {
  item?: WorkRoleListEntry;
  store: WorkRoleStore;
  roleData: WorkRoleReferenceData;
  // onDelete(a: DbKey<AppClient>[]): Promise<void>;
  mode?: FormMode;
  onCancel(): void;
}

@observer
export class WorkRoleForm extends React.Component<WorkRoleFormProps> {
  onCreate = async (item: WorkRoleUpdate): Promise<DbKey<WorkRole>> => {
    const { name } = item.workRole.value;
    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      // No auto-refresh
      const newId = await this.props.store.createWithRanges(item);

      toast.dismiss(toastId);
      toast.success(`Work Role ${name.value.en} created.`, {
        ...toastOptions,
        autoClose: 3000,
        onClose: this.props.onCancel
      });
      return newId;
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`Work Role ${name.value.en} create failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: this.props.onCancel
      });
      return '';
    }
  };

  onUpdate = async (item: WorkRoleUpdate): Promise<void> => {
    const { name } = item.workRole.value;
    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      await this.props.store.updateWithRanges(item);

      toast.dismiss(toastId);
      toast.success(`WorkRole ${name.value.en} updated.`, {
        ...toastOptions,
        autoClose: 3000,
        onClose: this.props.onCancel
      });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`WorkRole ${name.value.en} update failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: this.props.onCancel
      });
    }
  };

  onClone = async (item: WorkRoleUpdate): Promise<DbKey<WorkRole>> => {
    const { name } = item.workRole.value;
    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      const newId = await this.props.store.cloneWorkRole(item);

      toast.dismiss(toastId);
      toast.success(`WorkRole ${name.value.en} created.`, {
        ...toastOptions,
        autoClose: 3000,
        onClose: this.props.onCancel
      });
      return newId;
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`WorkRole ${name.value.en} update failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: this.props.onCancel
      });
      return '';
    }
  };

  // onDeletes = async (a: DbKey<AppClient>[]) => {
  //   try {
  //     await this.props.onDelete(a);
  //     runInAction(() => (this.fieldState.deletedClients = a.slice()));
  //   } catch (e) {
  //     runInAction(() => (this.fieldState.error = e as Error));
  //   }
  // };

  @action
  onCancel = () => {
    this.props.onCancel();
  };

  renderContent = () => {
    const {
      item: workrole,
      mode,
      roleData,
      store
      // toDelete,
    } = this.props;
    if ((mode === 'update' || mode === 'clone') && workrole) {
      return (
        <WorkRoleEditor
          item={workrole}
          roleData={roleData}
          store={store}
          mode={mode}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          onClone={this.onClone}
          role={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
      /// TODO: Delete
    } else {
      return (
        <WorkRoleEditor
          roleData={roleData}
          store={store}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          role={store.isSuperUser ? 'super' : 'client-admin'}
          mode={mode ? mode : 'create'}
        />
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.renderContent()}
        <ToastContainer newestOnTop />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/forms/workrole-form/workrole-form.tsx